import React from 'react';

import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DropdownMenu, HStack, IconButton } from '@rtkwlf/fenrir-react';

export const IconDropdownMenu: React.FC<
  React.PropsWithChildren<{
    title: string;
    icon: IconDefinition;
    iconLabel: string;
    defaultOpen?: boolean;
  }>
> = ({ children, title, icon, iconLabel, defaultOpen = false }) => {
  return (
    <HStack xAlign="center">
      <DropdownMenu.Root defaultOpen={defaultOpen}>
        <DropdownMenu.Trigger asChild fontSize="large">
          <IconButton aria-label={iconLabel}>
            <FontAwesomeIcon icon={icon} size="xs" />
          </IconButton>
        </DropdownMenu.Trigger>
        <DropdownMenu.Content align="end" width="16rem">
          <DropdownMenu.Header>
            <DropdownMenu.HeaderTitle maxWidth="12rem" truncate>
              {title}
            </DropdownMenu.HeaderTitle>
          </DropdownMenu.Header>
          <DropdownMenu.Group>{children}</DropdownMenu.Group>
        </DropdownMenu.Content>
      </DropdownMenu.Root>
    </HStack>
  );
};
